import React from 'react';
import { useNavigate } from 'react-router-dom';
import { InfoCircle } from 'iconoir-react';

export const checkLojaAberta = (loja) => {
  if (!loja?.horarios || loja.horarios.length === 0) {
    return true; // Se não tem horários, considera aberta
  }

  try {
    const today = new Date();
    const diasSemana = [1, 2, 4, 8, 16, 32, 64];
    const diaAtual = diasSemana[today.getDay()];
    
    const horarioHoje = loja.horarios.find(h => h.dia === diaAtual && h.ativo);
    
    if (!horarioHoje) return false;

    const [hiHora, hiMin] = horarioHoje.horario_inicial.split(':').map(Number);
    const [hfHora, hfMin] = horarioHoje.horario_final.split(':').map(Number);
    
    const horaAtual = today.getHours() * 60 + today.getMinutes();
    const horaInicio = hiHora * 60 + hiMin;
    const horaFim = hfHora * 60 + hfMin;

    return horaAtual >= horaInicio && horaAtual <= horaFim;
  } catch (error) {
    return false;
  }
};

const LojaFechadaAlert = ({ loja }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = React.useState(false);

  React.useEffect(() => {
    const checkIfOpen = () => {
      setIsOpen(checkLojaAberta(loja));
    };

    checkIfOpen();
    const interval = setInterval(checkIfOpen, 60000);
    return () => clearInterval(interval);
  }, [loja]);

  if (isOpen) return null;

  return (
    <div style={{
      backgroundColor: '#fef2f2',
      border: '1px solid #fecaca',
      borderRadius: '8px',
      padding: '12px 16px',
      margin: '16px 0',
      display: 'flex',
      alignItems: 'center',
      gap: '12px'
    }}>
      <InfoCircle width={24} height={24} style={{ color: '#dc2626', flexShrink: 0 }} />
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 600, color: '#991b1b', fontSize: '0.95rem', marginBottom: '4px' }}>
          Loja Fechada
        </div>
        <div style={{ color: '#7f1d1d', fontSize: '0.85rem' }}>
          No momento estamos fechados. <span onClick={() => navigate('/loja')} style={{ textDecoration: 'underline', cursor: 'pointer', fontWeight: 600 }}>Veja nosso horário de funcionamento.</span>.
        </div>
      </div>
    </div>
  );
};

export default LojaFechadaAlert;
